import {
  CalendarClearOutlineIcon,
  ResolveIcon,
  ReplyIcon,
} from '@dynamika-shared/ui/icons';
import { QueryEvent, QueryStatus } from '@restore/queries/queries.types';

export const QUERY_ACTION_MAP = {
  [QueryEvent.REOPEN]: { icon: CalendarClearOutlineIcon, label: 'Re-open' },
  [QueryEvent.CLOSE]: { icon: ResolveIcon, label: 'Resolve' },
  [QueryEvent.RESPOND]: { icon: ReplyIcon, label: 'Reply' },
  [QueryEvent.NEEDS_REWORK]: {
    icon: ReplyIcon,
    label: 'Reply',
  },
};

export const STATUS_QUERY_COLORS = {
  [QueryStatus.CREATED]: 'text-munsellPurple bg-snow',
  [QueryStatus.OPEN_SITE]: 'text-honoluluBlue bg-aliceBlue',
  [QueryStatus.OPEN_IAG]: 'text-vividTangelo bg-seashell',
  [QueryStatus.CLOSED]: 'text-yellowGreen bg-honeydew',
};

type ModalConfigProps = {
  title: string;
  okText: string;
  textareaLabel: string;
  textareaPlaceholder: string;
  messageRequiredMsg: string;
  subtitle: string;
  enableAttachments: boolean;
};

export const QUERY_MODAL_CONFIG: Partial<Record<QueryEvent, ModalConfigProps>> = {
  [QueryEvent.REOPEN]: {
    title: 'Re-open Query',
    okText: 'Re-open',
    textareaLabel: 'Reason to Re-open the Query',
    textareaPlaceholder: 'Enter your reason',
    messageRequiredMsg: 'Reason is required',
    subtitle: 'Please re-enter your credentials to re-open the query',
    enableAttachments: false,
  },
  [QueryEvent.CLOSE]: {
    title: 'Resolve Query',
    okText: 'Resolve',
    textareaLabel: 'Reason',
    textareaPlaceholder: 'Enter your reason',
    messageRequiredMsg: 'Reason is required',
    subtitle: 'Please re-enter your credentials to resolve the query',
    enableAttachments: false,
  },
  [QueryEvent.RESPOND]: {
    title: 'Reply Query',
    okText: 'Reply',
    textareaLabel: 'Response',
    textareaPlaceholder: 'Enter your response',
    messageRequiredMsg: 'Response is required',
    subtitle: 'Please re-enter your credentials to reply to the query',
    enableAttachments: true,
  },
  [QueryEvent.NEEDS_REWORK]: {
    title: 'Reply Query',
    okText: 'Submit',
    textareaLabel: 'Response',
    textareaPlaceholder: 'Enter your response',
    messageRequiredMsg: 'Response is required',
    subtitle: 'Please re-enter your credentials to reply to the query',
    enableAttachments: false,
  },
  [QueryEvent.SEND_MESSAGE]: {
    title: 'New Query Note',
    okText: 'Send Note',
    textareaLabel: 'Comment',
    textareaPlaceholder: 'Enter your Comment',
    messageRequiredMsg: 'Comment is required',
    subtitle:
      'Adding a comment does not change the query status. To respond and update the status, please use the ‘Reply’ action.',
    enableAttachments: true,
  },
};
